module.exports = __webpack_public_path__ + "img/2.54e43f9d.png";